<div class="flex min-h-0 flex-col gap-4 p-4 sm:min-h-[500px] sm:p-6">
  <div class="flex flex-wrap items-start justify-between gap-4">
    <h3 class="x-font-body-2-bold">{{ 'request_create.title' | translate }}</h3>
    @if ($step() !== 'success') {
      <div
        class="flex max-w-full items-center gap-2 overflow-x-auto no-scrollbar"
      >
        @for (s of steps; track s.step; let last = $last) {
          <span
            [class]="
              $step() === s.step
                ? 'flex size-8 items-center justify-center rounded-full bg-[var(--tui-background-accent-1)] text-sm font-semibold text-[var(--tui-text-primary-on-accent-1)]'
                : 'flex size-8 items-center justify-center rounded-full bg-[var(--tui-background-neutral-1-hover)] text-sm font-semibold text-[var(--tui-text-secondary)]'
            "
            >{{ s.label }}</span
          >
          @if (!last) {
            <span class="h-px w-8 bg-[var(--tui-background-neutral-1-hover)]"></span>
          }
        }
      </div>
    }
  </div>

  @if ($invalidFieldLabels().length) {
    <div
      class="rounded-md border border-[var(--tui-text-negative)] bg-[var(--tui-status-negative-pale)] p-3 text-sm text-[var(--tui-text-negative)]"
    >
      <div class="font-semibold">
        {{ 'request_create.required_title' | translate }}
      </div>
      <div>{{ $invalidFieldLabels().join(', ') }}</div>
    </div>
  }

  <div class="min-h-0 flex-1 overflow-y-auto" [formGroup]="form">
    @if ($step() === 'form-1a') {
      <x-request-create-step-1a
        [form]="form"
        [counterparties]="$counterparties()"
      />
    }
    @if ($step() === 'form-1b') {
      <x-request-create-step-1b [form]="form" [carBrands]="$carBrands()" />
    }
    @if ($step() === 'form-1c') {
      <x-request-create-step-1c
        [form]="form"
        [extraForm]="extraForm"
        [availableProducts]="$availableProducts()"
        [contractors]="$contractors()"
        [requestTypeControl]="form.controls.requestType"
        [requestTypeOptions]="$requestTypeOptions()"
        [selectedProducts]="$selectedProducts()"
        [subdivisions]="$subdivisions()"
        [visibleExtraFields]="$visibleExtraFields()"
        (addProduct)="addProduct($event.productId, $event.amount)"
        (removeProduct)="removeProduct($event)"
      />
    }
    @if ($step() === 'files') {
      <div class="flex flex-col gap-4">
        <div>
          <h4 class="x-font-h4">
            {{ 'request_create.section_files' | translate }}
          </h4>
          <p class="mt-1 text-sm text-[var(--tui-text-secondary)]">
            {{ 'request_create.files_hint' | translate }}
          </p>
        </div>
        <x-request-form-files-common
          [files]="null"
          [fileCats]="null"
          [renderModalLayoutInline]="true"
          [requestFilesPersonType]="RequestFilesPersonType.CLIENT"
        />
      </div>
    }
    @if ($step() === 'success') {
      <x-request-create-success
        [createdRequests]="$createdRequests()"
        (navigateToRequest)="navigateToRequest()"
        (closeDialog)="close()"
      />
    }
  </div>

  @if ($step() !== 'success') {
    <div
      class="flex flex-col-reverse gap-3 border-t border-[var(--tui-background-neutral-1-hover)] pt-4 sm:flex-row sm:justify-end"
    >
      @if ($step() !== 'form-1a') {
        <button
          tuiButton
          type="button"
          size="m"
          appearance="flat"
          class="w-full sm:w-auto"
          (click)="goBack()"
        >
          {{ 'request_create.back' | translate }}
        </button>
      }
      @if ($step() === 'files') {
        <button
          tuiButton
          type="button"
          size="m"
          class="w-full sm:w-auto"
          appearance="flat"
          [disabled]="$isSendingToWork()"
          (click)="finishFilesStep()"
        >
          {{ 'request_create.finish' | translate }}
        </button>
        <button
          tuiButton
          type="button"
          size="m"
          class="w-full sm:w-auto"
          [loading]="$isSendingToWork()"
          [disabled]="$isSendingToWork()"
          (click)="sendToWork()"
        >
          {{ 'request_create.send_to_work' | translate }}
        </button>
      } @else {
        <button
          tuiButton
          type="button"
          size="m"
          class="w-full sm:w-auto"
          [loading]="$isSubmitting()"
          [disabled]="$isSubmitting()"
          (click)="goNext()"
        >
          @if ($step() === 'form-1c') {
            {{ 'request_create.create' | translate }}
          } @else {
            {{ 'request_create.next' | translate }}
          }
        </button>
      }
    </div>
  }
</div>
